<template>
  <div class="datepicker-trigger">
    <div class="dropdown-trigger" @click="enableDatePicker">
      <button
        class="button button-dropdown is-flex"
        aria-haspopup="true"
        aria-controls="dropdown-menu"
        id="datepicker-trigger"
      >
        <div class="columns width-100">
          <div class="column calender-icon has-text-left is-narrow">
            <img src="/static/img/calender_icon.svg" />
          </div>
          <div class="column is-paddingless">
            <span class="is-size-7" v-if="date.selectedDate || value">{{ date.selectedDate || prettyDate(value) }}</span>
            <span class="is-size-7" v-else-if="showCurrentDate && !date.selectedDate">{{(prettyDate(currentDate))}}</span>
          </div>
          <div class="column is-paddingless has-text-right">
            <img src="/static/img/ic-down-arrow.svg" class="down-arrow" />
          </div>
        </div>
      </button>
    </div>
    <div class="columns is-paddingless has-text-centered date-input" v-if="isDatePickerVisible">
      <div class="column is-paddingless has-text-centered">
        <div class="field">
          <div class="control">
            <img src="/static/img/calender_icon.svg"/>
            <input type="text" class="date-text" v-model="date.selectedDate" @keyup.enter="handleCustomDate">
          </div>
        </div>
      </div>
    </div>
    <AirbnbStyleDatepicker
      trigger-element-id="datepicker-trigger"
      :class="[{'airbnb-datepicker': isDatePickerVisible}]"
      :trigger="true"
      :mode="`single`"
      :monthsToShow="1"
      :fullscreenMobile="false"
      :dateOne="date.dateOne"
      :endDate="currentDate"
      :closeAfterSelect="true"
      :showShortcutsMenuTrigger="false"
      @opened="isDatePickerVisible = true"
      @date-one-selected="handleDateSelected"
    >
      <template slot="previous-month-icon">
        <img src="/static/img/ic-left-arrow.svg" alt="next-month">
      </template>
      <template slot="next-month-icon">
        <img src="/static/img/ic-right-arrow.svg" alt="next-month">
      </template>
    </AirbnbStyleDatepicker>
  </div>
</template>

<script>
  /* eslint-disable indent,no-new,no-undef,no-unused-expressions, no-useless-escape */
  import moment from 'moment'
  import format from 'date-fns/format'

  export default {
    name: 'SingleDatePicker',
    props: {
      value: {
        type: String,
        default: null
      },
      format: {
        type: String,
        default: 'YYYY-MM-DD'
      },
      showCurrentDate: {
        type: Boolean,
        default: false
      }
    },
    data () {
      return {
        date: {
          endDate: '',
          dateOne: '',
          startDate: '',
          selectedDate: ''
        },
        trigger: false,
        isDatePickerVisible: false
      }
    },
    computed: {
      /**
       * Return current date
       *
       * @returns {string}
       */
      currentDate () {
        return moment().format('YYYY-MM-DD')
      }
    },
    methods: {
      prettyDate (date) {
        return moment(date, ['MM-DD-YYYY', 'YYYY-MM-DD']).format(this.format)
      },
      formatDates (dateOne) {
        let formattedDates = ''
        if (dateOne) {
          formattedDates = format(dateOne, this.format)
        }
        return formattedDates
      },
      enableDatePicker () {
        this.isDatePickerVisible = !this.isDatePickerVisible
      },
      handleDateSelected (value) {
        this.date.selectedDate = this.prettyDate(value)
        this.isDatePickerVisible = false
          this.$emit('onSingleDateSelected', {
          date: value
        })
      },
      handleCustomDate () {
        if (moment(this.date.selectedDate, ['MM-DD-YYYY', 'YYYY-MM-DD']).isValid()) {
          this.date.dateOne = moment(this.date.selectedDate, ['MM-DD-YYYY', 'YYYY-MM-DD']).format('YYYY-DD-MM')
        }
      }
    },
    watch: {
      'date.dateOne': (newVal) => {
        if (!newVal) {
          this.date.dateOne = moment((this.date.selectedDate || this.value), ['MM-DD-YYYY', 'YYYY-MM-DD']).format('YYYY-DD-MM')
          console.log('+++++++', newVal, this.date.dateOne)
        }
      }
    },
    filters: {
      formatDate (date) {
        return moment(date).format(this.format)
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import '@/assets/scss/variables.scss';

  .datepicker-trigger {
    width: 300px;
    z-index: 999;
    max-width: 300px;
    /*position: absolute;*/
    overflow: visible;

    .button.button-dropdown{
      align-content: baseline;

      .calender-icon {
        padding: 0 0 7px 0;
      }
      .down-arrow {
        right: -10px;
        bottom: 3px;
        position: relative;
      }
    }
    .date-input {
      top: 15px;
      left: 10%;
      z-index: 101;
      position: relative;

      img {
        top: 25%;
        left: 7%;
        position: absolute;
      }
      .date-text {
        color: #8A8C91;
        padding: 8px 12px 8px 50px;
        border: solid 1px rgba(88, 89, 91, 0.32);
      }
    }
    .airbnb-datepicker, .asd__wrapper--datepicker-open {
      top: 39px !important;
      left: 0px !important;
      width: 300px !important;
      display: block !important;
      margin: 0.3% 0 0 0;
      z-index: 100 !important;
      position: absolute !important;

      &>>>.asd__datepicker-header {
        margin-top: 40px;
      }
      &>>>.asd__change-month-button>button {
        border: none;
        outline: none;
      }
      &>>>.asd__month-name {
        color: $text-color;
        font-size: 13px;
        font-weight: normal;
      }
      &>>>.asd__month-table {
        .asd__week {
          .asd__day {
            line-height: 0;
            height: 35px;
          }
        }
        .asd__week {
          .asd__day--enabled {
            border: none !important;

            .asd__day-button {
              font-size: 11px;
            }
          }
        }
      }
      &>>>.asd__day--enabled {
        border: none !important;

        &.asd__day--selected {
          border: none !important;
          border-radius: 50%;
          background-color: $date-selected-color !important;
        }
      }
    }
    .fas.fa-angle-down {
      /*font-size: 1.2rem;*/
      font-weight: 600;
    }
  }

/* Helper css begins */
  .width-100 {
    width: 100%;
  }
/* Helper css ends */
</style>



// WEBPACK FOOTER //
// src/components/SingleDatePicker.vue